import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Layout, Dropdown, Menu, Grid, Badge, Avatar, Button } from "antd";
import {
  MenuOutlined,
  HomeOutlined,
  UserOutlined,
  WalletOutlined,
  TeamOutlined,
  HeartOutlined,
  LogoutOutlined,
  BellOutlined,
} from "@ant-design/icons";

import "./ProfileHeader.css";

const { Header } = Layout;
const { useBreakpoint } = Grid;

const ProfileHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [userName, setUserName] = useState("User");

  useEffect(() => {
    const name = localStorage.getItem("username") || "User";
    setUserName(name);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/User_Login");
  };

  const menuItems = useMemo(
    () => [
      {
        key: "/User_Home",
        icon: <HomeOutlined />,
        label: <Link to="/User_Home">Home</Link>,
      },
      {
        key: "/User_Profile_User",
        icon: <UserOutlined />,
        label: <Link to="/User_Profile_User">My Profile</Link>,
      },
      {
        key: "/User_Recharge",
        icon: <WalletOutlined />,
        label: <Link to="/User_Recharge">Recharge</Link>,
      },
      {
        key: "/User_Apply",
        icon: <HeartOutlined />,
        label: <Link to="/User_Apply">Apply</Link>,
      },
      {
        key: "/User_Auto_Match_User",
        icon: <TeamOutlined />,
        label: <Link to="/User_Auto_Match_User">Matches</Link>,
      },
      {
        key: "/User_Added_User",
        icon: <UserOutlined />,
        label: <Link to="/User_Added_User">Refer User</Link>,
      },
      {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Logout",
        danger: true,
        onClick: handleLogout,
        className: "logout-menu-item",
      },
    ],
    []
  );

  const desktopMenu = (
    <Menu
      mode="horizontal"
      className="ph-nav-menu"
      selectedKeys={[location.pathname]}
      items={menuItems}
    />
  );

  const mobileMenu = (
    <Menu
      mode="vertical"
      className="ph-mobile-menu"
      selectedKeys={[location.pathname]}
      items={menuItems}
    />
  );

  return (
    <Header className="ph-header">
      <div className="ph-bg-orb orb-one"></div>
      <div className="ph-bg-orb orb-two"></div>

      <div className="ph-header-inner">
        {/* Logo */}
        <div className="ph-logo-wrapper">
          <Link to="/" className="ph-logo-link">
            <div className="ph-logo-badge">❤️</div>
            <div className="ph-logo-content">
              <span className="ph-logo-text">Community</span>
              <span className="ph-logo-highlight">Rishtey</span>
              <span className="ph-logo-subtitle">Your trusted matrimony space</span>
            </div>
          </Link>
        </div>

        {/* Desktop Nav */}
        {screens.md ? (
          <>
            <div className="ph-desktop-menu">{desktopMenu}</div>

            <div className="ph-right-desktop">
              <div className="ph-user-chip">
                <Avatar
                  size={36}
                  src={localStorage.getItem("avatar")}
                  icon={<UserOutlined />}
                  className="ph-user-avatar"
                />
                <div className="ph-user-meta">
                  <span className="ph-user-label">Welcome</span>
                  <span className="ph-user-name">{userName}</span>
                </div>
              </div>

              <Button className="ph-logout-btn" onClick={handleLogout}>
                <LogoutOutlined />
                Logout
              </Button>
            </div>
          </>
        ) : (
          <div className="ph-mobile-controls">
            <Badge count={3} size="small" className="ph-notif-badge">
              <BellOutlined className="ph-notif-icon" />
            </Badge>

            <Dropdown overlay={mobileMenu} placement="bottomRight" trigger={["click"]}>
              <div className="ph-mobile-trigger">
                <Avatar
                  size={34}
                  src={localStorage.getItem("avatar")}
                  icon={<UserOutlined />}
                  className="ph-user-avatar"
                />
                <div className="ph-mobile-user">
                  <span className="ph-mobile-label">Hi</span>
                  <span className="ph-mobile-name">{userName}</span>
                </div>
                <MenuOutlined className="ph-menu-icon" />
              </div>
            </Dropdown>
          </div>
        )}
      </div>
    </Header>
  );
};

export default ProfileHeader;